import React from 'react';
import { Button } from './Common';

// formKey is the key in the finding form this suggestion is applied to, so it
// has to be a key the form actually reads. 'cvssVector' was not one -- the
// vector box reads cvssTags -- so Apply on a suggested vector wrote a key
// nothing displayed and nothing saved, and looked like a dead button.
const FIELD_CONFIG = [
  { key: 'severity', label: 'Severity', formKey: 'severity' },
  { key: 'cvss_score', label: 'CVSS Score', formKey: 'cvssScore' },
  { key: 'cvss_vector', label: 'CVSS Vector', formKey: 'cvssTags' },
  { key: 'description', label: 'Description', formKey: 'details', multiline: true },
  { key: 'recommendation', label: 'Recommendation', formKey: 'recommendation', multiline: true },
  { key: 'references', label: 'References', formKey: 'references', multiline: true },
];

export default function AiSuggestPanel({ suggestions, loading, error, onApply, onUseTemplate, onClose }) {
  if (!loading && !suggestions && !error) return null;

  return (
    <div style={{
      border: '1px solid var(--border)', borderRadius: 8,
      background: 'var(--bg)', padding: 16, marginTop: 16,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 14 }}>🤖</span>
          <span style={{ fontSize: 13, fontWeight: 600 }}>AI Suggestions</span>
        </div>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: 'var(--text-secondary)', fontFamily: 'inherit' }}>×</button>
      </div>

      {loading && (
        <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-secondary)', fontSize: 13 }}>
          Analyzing finding... this may take a moment.
        </div>
      )}

      {error && (
        <div style={{ padding: '8px 12px', borderRadius: 6, background: 'rgba(245,158,11,0.1)', color: '#f59e0b', fontSize: 12, marginBottom: 12 }}>
          {error}
        </div>
      )}

      {suggestions && !loading && (
        <>
          {FIELD_CONFIG.map(field => {
            const value = suggestions[field.key];
            if (value === null || value === undefined) return null;
            return (
              <div key={field.key} style={{ marginBottom: 10, padding: '8px 12px', borderRadius: 6, background: 'var(--bg-card)', border: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                  <span style={{ fontSize: 10, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{field.label}</span>
                  <button onClick={() => onApply(field.formKey, field.key === 'cvss_score' ? parseFloat(value) : String(value))}
                    style={{ background: 'var(--primary)', color: '#fff', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 10, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                    Apply
                  </button>
                </div>
                <div style={{ fontSize: 12, color: 'var(--text)', whiteSpace: field.multiline ? 'pre-wrap' : 'normal', maxHeight: field.multiline ? 100 : 'none', overflowY: 'auto' }}>
                  {String(value)}
                </div>
              </div>
            );
          })}

          {suggestions.matching_templates?.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>Matching Templates</div>
              {suggestions.matching_templates.slice(0, 5).map(t => (
                <div key={t.id} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '6px 10px', borderRadius: 4, marginBottom: 3,
                  background: 'var(--bg-card)', border: '1px solid var(--border)',
                }}>
                  <div>
                    <span style={{ fontSize: 12, fontWeight: 500 }}>{t.title}</span>
                    {t.severity && <span style={{ marginLeft: 6, fontSize: 10, color: 'var(--text-secondary)' }}>[{t.severity}]</span>}
                  </div>
                  <button onClick={() => onUseTemplate(t.id)}
                    style={{ background: 'none', border: '1px solid var(--primary)', borderRadius: 4, padding: '2px 8px', fontSize: 10, color: 'var(--primary)', cursor: 'pointer', fontFamily: 'inherit' }}>
                    Use
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
